import TableRow from '@mui/material/TableRow';
import { CheckBoxInput } from '../../style';
import CellsRow from './CellsRow';
import { IDebts, IGetDebtsResult, IMandatoryDebt } from '../../../../hooks/useDebts';

interface IConfigureTableRowProps {
  data: any;
  configuredColumns: any[];
  setIsChecked: (bool: boolean | any) => void;
  isChecked: { [key: string]: boolean };
  handleRowAction?: (item: any) => any;
  setMandatoryDebts?: (item: IMandatoryDebt[]) => void;
}

export default function ConfiguredTableRow({
  data,
  configuredColumns,
  setIsChecked,
  isChecked,
  handleRowAction,
  setMandatoryDebts
}: IConfigureTableRowProps) {
  return (
    <>
      {data &&
        data?.data?.map((each: IDebts) => {
          const totalDebts = (Number(each?.price ?? 0) + Number(each?.totalMandatory ?? 0));
          const eachPriceDebts = Number(each?.price ?? 0);
          const eachMandatoryDebts = Number(each?.totalMandatory ?? 0);

          const tableCells = [
            {
              id: `item-0`,
              value: each?.vehiclePlate ?? "--",
            },
            {
              id: `item-1`,
              value: each?.vehicleUF ?? "--",
            },
            {
              id: `item-2`,
              value: each?.type.toUpperCase() ?? "--",
            },
            {
              id: `item-3`,
              value: each?.description + (each?.additionalDescription ? " - " + each?.additionalDescription : "") || "--",
              style: {
                display: "-webkit-box"
              }
            },
            {
              id: `item-4`,
              value: eachPriceDebts > 0 ? `R$ ${eachPriceDebts.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}` : "--",
            },
            {
              id: `item-5`,
              value: eachMandatoryDebts > 0 ?
                <span
                  style={{
                    color: "#F58220",
                    fontWeight: 700,
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                  onClick={() => {
                    if(setMandatoryDebts) setMandatoryDebts(each?.onCheck?.select)
                    if(handleRowAction) handleRowAction(true)
                  }}
                >
                  {`R$ ${eachMandatoryDebts.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                </span> : "--",
            },
            {
              id: `item-6`,
              value: totalDebts > 0 ? `R$ ${totalDebts.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}` : "--",
            },
            {
              id: `item-7`,
              value: each?.driverName ?? "--",
            },
            {
              id: `item-8`,
              value: each?.isExpired ? "Atrasado" : "A pagar",
              style: {
                color: each?.isExpired ? "#FC0027" : "#EDB903",
                fontWeight: 700,
              }
            },
            {
              id: `item-9`,
              value: each?.consultDate
                ? `${new Date(each?.consultDate)?.toLocaleDateString()} - ${new Date(
                  each?.consultDate
                )?.toLocaleTimeString('pt-BR', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}`
                : "--",
            },
            {
              id: `item-10`,
              value: each?.expirationDate
                ? new Date(each?.expirationDate)?.toLocaleDateString()
                : "--",
            }
          ];

          const columns = configuredColumns
            .filter(col => col.show)
            .map(col => {
              return tableCells.find(cell => cell.id == col.id)
            })

          return (
            <TableRow key={each?.debtsCode}>
              <td style={{
                padding: "0 0 0 16px",
                minWidth: "0",
                textAlign: "left"
              }}>
                <CheckBoxInput
                  type="checkbox"
                  checked={isChecked[each.debtsCode]}
                  onChange={() =>
                    setIsChecked((prev: any) => ({
                      ...prev,
                      [String(each.debtsCode)]:
                        !isChecked[each.debtsCode],
                    }))
                  }
                />
              </td>
              {columns.map((column) =>
                <CellsRow content={column?.value} style={column?.style} />
              )}
            </TableRow>
          )
        })}
    </>
  )
}